import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
const CHECKOUT_URL = 'https://digifactorymax.net/cart/57874198823176:1';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  showIcon = true,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      // Fire Meta Pixel AddToCart event before redirect
      try {
        const fbq = (window as any).fbq;
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: 'The Ultimate Auction Secrets Blueprint 2026',
            content_ids: ['57874198823176'],
            content_type: 'product',
            value: 6.36,
            currency: 'USD'
          });
        }
      } catch (err) {
        /* no-op */
      }
      window.location.href = CHECKOUT_URL;
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative inline-flex items-center justify-center gap-3 
        bg-gold hover:bg-gold-light text-black font-semibold 
        px-8 py-4 rounded-sm transition-colors
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gold focus-visible:ring-offset-black
        shadow-gold-glow
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-236">
      <span className="text-lg tracking-wide" data-id="element-237">{children}</span>
      {showIcon && <Download className="w-5 h-5" data-id="element-238" />}
    </motion.button>;
}